import mergeFilterInputs from 'mergeFilterInputs';
import buildFilterInput from 'utils/buildFilterInput';

/**
 * The filters an override group's request is sent with: the chart's, plus
 * the group's own. A group that overrides filters drops the chart's, so only
 * its own apply. Its metrics' dataset filters are sent on each metric (see
 * useToMetricInput), so they apply either way.
 */
const toGroupFilterInput = ({
  filterInput,
  overrides,
  platesToFilterInput,
}: {
  filterInput: FilterInput;
  overrides: V5SeriesQueryOverrides;
  platesToFilterInput: (plates: FilterPlateType[]) => FilterInput;
}): FilterInput => {
  const base = overrides.isFiltersOverridden
    ? buildFilterInput({ scopes: [], drillDowns: [] })
    : filterInput;
  const { filters } = overrides;
  return filters && filters.length > 0
    ? mergeFilterInputs(base, platesToFilterInput(filters))
    : base;
};

export default toGroupFilterInput;
